import { revocationsUrl, scansUrl, ticketsUrl } from "constants/apiurls";
import { DB_RESPONSE_OK } from "constants/dbStatuses";
import {
	clearOfflineTicketsFromIndexedDb,
	getOfflineTicketsFromIndexedDb,
	writeRevocationsToIndexedDb,
	writeScansToIndexedDb,
	writeTicketsToIndexedDb,
} from "indexedDb/operations";
import { encodeQueryParams } from "util/api";

// Helpers to do different kinds of synchronization actions,
// available to be called from either SW or the main window as needed.

export const syncOfflineScans = async (apikey: string, device_name?: string): Promise<number> => {
	const offlineTickets = await getOfflineTicketsFromIndexedDb();
	if (offlineTickets.status === DB_RESPONSE_OK) {
		if (offlineTickets.data.length === 0) {
			// nothing to sync
			return 0;
		}
		const resp = await fetch(scansUrl, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				apikey: apikey,
				tickets: offlineTickets.data.map(ticket => {
					if (ticket.section_id === null) {
						// @ts-expect-error
						delete ticket.section_id;
						// @ts-expect-error
						delete ticket.id;
					}
					return ticket;
				}),
				device: device_name || "Unnamed device",
			}),
		});
		if (resp.ok) {
			const dbr = await clearOfflineTicketsFromIndexedDb();
			if (dbr.status === DB_RESPONSE_OK) {
				return offlineTickets.data.length;
			}
			throw new Error("Failed to clear posted offline scans");
		}
		throw new Error("Failed to post offline scans");
	}
	throw new Error("Failed to get offline tickets from idb");
};

export const syncNewTickets = async (apikey: string, after: number): Promise<number> => {
	const resp = await fetch(ticketsUrl + encodeQueryParams({ apikey, after }));
	if (resp.ok) {
		const data = await resp.json();
		const dbr = await writeTicketsToIndexedDb(data);
		if (dbr.status === DB_RESPONSE_OK) {
			return dbr.data.added;
		}
		throw new Error("Failed to save new tickets", { cause: dbr });
	}
	throw new Error("Failed to fetch new tickets", { cause: resp });
};

export const syncNewScans = async (apikey: string, after: number): Promise<number> => {
	const resp = await fetch(scansUrl + encodeQueryParams({ apikey, after }));
	if (resp.ok) {
		const data = await resp.json();
		const dbr = await writeScansToIndexedDb(data);
		if (dbr.status === DB_RESPONSE_OK) {
			return data.length;
		}
		throw new Error("Failed to save new scans");
	}
	throw new Error("Failed to fetch new scans");
};

export const syncNewRevocations = async (apikey: string, after: number): Promise<number> => {
	const resp = await fetch(revocationsUrl + encodeQueryParams({ apikey, after }));
	if (resp.ok) {
		const data = await resp.json();
		const dbr = await writeRevocationsToIndexedDb(data);
		if (dbr.status === DB_RESPONSE_OK) {
			return data.length;
		}
		throw new Error("Failed to save new revocations");
	}
	throw new Error("Failed to fetch new revocations");
};
